<template>
  <div id="MainContainer" class="min-h-screen overflow-auto">
    <Header></Header>
    <Nav class="md:hidden" :menu-list-item="menuListItems" :user="user" />
    <router-view class="min-h-full" />
  </div>
</template>

<script>
import Nav from "./Nav";
import Header from "./Header";

export default {
  name: "MainContainer",
  components: {
    Nav,
    Header
  },
  data() {
    return {
      menuListItems: [
        {
          id: 0,
          icon: "#c-icon-dashboard",
          title: "Overview",
          url: "#"
        },
        {
          id: 1,
          icon: "#c-icon-analytics",
          title: "Analitycs",
          url: "/dashboard/employee"
        },
        {
          id: 2,
          icon: "#c-icon-vehicles",
          title: "Cards",
          url: "#"
        }
      ],
      user: {
        firstName: "Joshua",
        lastName: "Bakare"
      }
    };
  }
};
</script>

<style>
#MainContainer {
  text-align: center;
  color: #2c3e50;
  background-color: #f4f6fc;
}
</style>
